window.typeahead = require('corejs-typeahead/dist/typeahead.jquery.min');
window.Bloodhound = require('corejs-typeahead/dist/bloodhound.min');

(function($) {
  let Typeaheads = function(element, options) {
    let elem = $(element);
    let obj = this;

    let settings = $.extend(
      {
        id: null,
        token: null,
        fields: null,
        orderBy: null,
        sortedBy: 'asc',
        urls: {},
      },
      options || {},
    );

    /*
     * Public method
     * Can be called outside class
     */
    this.search = function() {
      // console.info(queryString.parse(location.hash));
      let engine = new Bloodhound({
        remote: {
          url: settings.urls.search + '?q=%QUERY%',
          wildcard: '%QUERY%',
        },
        // identify: function(obj) { return obj.name; },
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
      });

      $('.typeahead').typeahead(
        {
          hint: true,
          highlight: true,
          minLength: 1,
        },
        {
          source: engine.ttAdapter(),

          // This will be appended to "tt-dataset-" to form the class name of the suggestion menu.
          name: 'search-result',

          display: 'name',
          // the key from the array we want to display (name,id,email,etc...)
          templates: {
            empty: [
              //`<span class="dropdown-item-text">Nothing found.</span>`
            ],
            header: [],
            suggestion: function(data) {
              let description =
                data.description && data.description.length > 0
                  ? `<p class="suggestion-caption">${data.description}</p>`
                  : '';

              return `<a href="${data.url}" class="dropdown-item" >
                                    <div class="form-row align-items-center justify-content-center">
                                        <div class="col-3">
                                            <img src="${
                                              data.picture
                                            }" class="suggestion-image img-fluid img-center" />
                                        </div>
                                        <div class="col-9">
                                            <div class="d-flex w-100 justify-content-between">
                                              <div class="suggestion-title">${data.name}</div>
                                              <small class="ml-2">${data.type}</small>
                                            </div>
                                            ${description}
                                        </div>
                                    </div>
                                </a>`;
            },
          },
        },
      );

      $('.twitter-typeahead').bind('typeahead:select', function(ev, suggestion) {
        window.location.href = suggestion.url;
      });
    };

    parseHashAndToggle = () => {
      const currentHash = _.head(_.keys(queryString.parse(location.hash)));

      toggleSection(currentHash);
    };
  };

  $.typeaheads = function(options) {
    return new Typeaheads(null, options);
  };
})(jQuery);
